import React, { useState, useEffect } from "react";
import { APP_CONFIG, config } from "../../config";

const ABXGamePlayer = () => {
  const [selectedGame, setSelectedGame] = useState("abx_fruits_and_bars");
  const [gameConfig, setGameConfig] = useState({
    currency: "USD",
    language: "en_US",
    home_page: "/",
    token: "test_user_123|session_456|abc123def456",
    billing: "your_billing_uuid_here", // Replace with actual billing UUID
    kf_list: [1, 5, 10, 50, 100, 500],
    bet_per_line: [1, 2, 5, 10, 20],
    kf: "1",
    path: "/abx-games/",
  });
  const [gameUrl, setGameUrl] = useState("");
  const [showConfig, setShowConfig] = useState(true);

  const availableGames = [
    { id: "abx_fruits_and_bars", name: "Fruits and Bars" },
    { id: "abx_egypt_riddles", name: "Egypt Riddles" },
    { id: "abx_lucky_sevens", name: "Lucky Sevens" },
    { id: "abx_treasure_island", name: "Treasure Island" },
    { id: "abx_golden_pyramid", name: "Golden Pyramid" },
    { id: "abx_aztec_gold", name: "Aztec Gold" },
    { id: "abx_diamond_mine", name: "Diamond Mine" },
  ];

  // Generate the complete HTML for the game iframe
  const generateGameHTML = () => {
    return `<!DOCTYPE html>
<html>
<head>
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, minimal-ui" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content="black" />
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    
    <style>
        body, html {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%);
            font-family: 'Arial', sans-serif;
        }
        
        #game-content {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }
        
        .loading-container {
            text-align: center;
            color: #fff;
            z-index: 1000;
        }
        
        .loading-spinner {
            width: 50px;
            height: 50px;
            border: 3px solid rgba(255,255,255,0.3);
            border-radius: 50%;
            border-top-color: #ff6b6b;
            animation: spin 1s ease-in-out infinite;
            margin: 0 auto 20px;
        }
        
        @keyframes spin {
            to { transform: rotate(360deg); }
        }
        
        .error-container {
            text-align: center;
            color: #ff6b6b;
            padding: 20px;
            background: rgba(0,0,0,0.8);
            border-radius: 10px;
            max-width: 500px;
            margin: 20px;
        }
        
        .error-title {
            font-size: 24px;
            margin-bottom: 10px;
            font-weight: bold;
        }
        
        .error-details {
            font-size: 14px;
            line-height: 1.5;
            opacity: 0.8;
        }
        
        .retry-btn {
            background: #ff6b6b;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            margin-top: 15px;
            font-size: 14px;
        }
        
        .retry-btn:hover {
            background: #ff5252;
        }
        
        .config-info {
            position: absolute;
            top: 10px;
            right: 10px;
            background: rgba(0,0,0,0.7);
            color: white;
            padding: 10px;
            border-radius: 5px;
            font-size: 12px;
            max-width: 200px;
        }
    </style>
    
    <!-- ABX Game Scripts -->
    <script type="text/javascript" src="${
      gameConfig.path
    }abx-play-games.json"></script>
    <script src="${gameConfig.path}loader/loader.js"></script>
</head>
<body>
    <div id="game-content">
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <div>Loading ${selectedGame}...</div>
            <div style="font-size: 12px; margin-top: 10px; opacity: 0.7;">
                Initializing game client...
            </div>
        </div>
    </div>
    
    <div class="config-info">
        <strong>Game:</strong> ${selectedGame}<br>
        <strong>Currency:</strong> ${gameConfig.currency}<br>
        <strong>Language:</strong> ${gameConfig.language}<br>
        <strong>Billing:</strong> ${gameConfig.billing}
    </div>
    
    <script type="text/javascript">
        console.log('ABX Game Loader Starting...');
        console.log('Game ID:', '${selectedGame}');
        console.log('Config:', ${JSON.stringify(gameConfig)});
        
        // Error handling
        window.onerror = function(msg, url, lineNo, columnNo, error) {
            console.error('Game Error:', msg, 'at', url, ':', lineNo);
            document.getElementById('game-content').innerHTML = 
                '<div class="error-container">' +
                '<div class="error-title">Game Loading Error</div>' +
                '<div class="error-details">' + msg + '</div>' +
                '<button class="retry-btn" onclick="location.reload()">Retry</button>' +
                '</div>';
            return false;
        };
        
        // Check if ABX scripts are loaded
        function checkABXScripts() {
            if (typeof window.init_loader === 'function') {
                initializeGame();
            } else {
                console.log('Waiting for ABX scripts to load...');
                setTimeout(checkABXScripts, 500);
            }
        }
        
        function initializeGame() {
            try {
                console.log('Initializing ABX game loader...');
                window.init_loader({
                    currency: "${gameConfig.currency}",
                    language: "${gameConfig.language}",
                    home_page: "${gameConfig.home_page}",
                    token: "${gameConfig.token}",
                    billing: "${gameConfig.billing}",
                    game: "${selectedGame}",
                    kf_list: [${gameConfig.kf_list.join(",")}],
                    bet_per_line: [${gameConfig.bet_per_line.join(",")}],
                    kf: "${gameConfig.kf}",
                    path: "${gameConfig.path}"
                });
                console.log('ABX game loader initialized successfully');
            } catch (error) {
                console.error('Failed to initialize game:', error);
                document.getElementById('game-content').innerHTML = 
                    '<div class="error-container">' +
                    '<div class="error-title">Initialization Error</div>' +
                    '<div class="error-details">Failed to initialize game: ' + error.message + '</div>' +
                    '<div class="error-details" style="margin-top: 10px;"><strong>Possible issues:</strong><br>' +
                    '• Billing UUID not configured<br>' +
                    '• Proxy routes not set up<br>' +
                    '• Network connectivity issues<br>' +
                    '• Invalid game ID</div>' +
                    '<button class="retry-btn" onclick="location.reload()">Retry</button>' +
                    '</div>';
            }
        }
        
        // Start the initialization process
        checkABXScripts();
        
        // Timeout fallback
        setTimeout(function() {
            if (document.querySelector('.loading-container')) {
                document.getElementById('game-content').innerHTML = 
                    '<div class="error-container">' +
                    '<div class="error-title">Loading Timeout</div>' +
                    '<div class="error-details">Game failed to load within 30 seconds</div>' +
                    '<div class="error-details" style="margin-top: 10px;"><strong>Check:</strong><br>' +
                    '• Internet connection<br>' +
                    '• ABX server availability<br>' +
                    '• Proxy configuration</div>' +
                    '<button class="retry-btn" onclick="location.reload()">Retry</button>' +
                    '</div>';
            }
        }, 30000);
    </script>
</body>
</html>`;
  };

  // Create data URL for iframe
  const createGameDataUrl = () => {
    const html = generateGameHTML();
    const blob = new Blob([html], { type: "text/html" });
    return URL.createObjectURL(blob);
  };

  // Update game URL when config changes
  useEffect(() => {
    setGameUrl(createGameDataUrl());
  }, [selectedGame, gameConfig]);

  const updateConfig = (key, value) => {
    setGameConfig((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const copyConfigAsJSON = () => {
    const configWithGame = { ...gameConfig, game: selectedGame };
    navigator.clipboard.writeText(JSON.stringify(configWithGame, null, 2));
  };

  const copyProxyConfig = () => {
    const proxyConfig = `// Express.js Proxy Configuration
const express = require('express');
const { createProxyMiddleware } = require('http-proxy-middleware');

const app = express();

// Proxy for ABX game resources
app.use('/abx-games', createProxyMiddleware({
  target: 'http://media.abx-play.fun',
  changeOrigin: true,
  pathRewrite: {
    '^/abx-games': '',
  },
  onProxyReq: (proxyReq, req, res) => {
    proxyReq.setHeader('X-Real-IP', req.ip);
  }
}));

// Proxy for ABX game API
app.use('/:billingUuid/api', createProxyMiddleware({
  target: 'http://connect.abx-play.fun:8080',
  changeOrigin: true,
  onProxyReq: (proxyReq, req, res) => {
    proxyReq.setHeader('X-Real-IP', req.ip);
  }
}));`;

    navigator.clipboard.writeText(proxyConfig);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          ABX Casino Game Integration Test
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Configuration Panel */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-700">
                  Configuration
                </h2>
                <button
                  onClick={() => setShowConfig(!showConfig)}
                  className="text-blue-500 hover:text-blue-700 text-sm"
                >
                  {showConfig ? "Hide" : "Show"}
                </button>
              </div>

              {showConfig && (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Game
                    </label>
                    <select
                      value={selectedGame}
                      onChange={(e) => setSelectedGame(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      {availableGames.map((game) => (
                        <option key={game.id} value={game.id}>
                          {game.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Currency
                    </label>
                    <select
                      value={gameConfig.currency}
                      onChange={(e) => updateConfig("currency", e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      <option value="RUB">RUB</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Language
                    </label>
                    <select
                      value={gameConfig.language}
                      onChange={(e) => updateConfig("language", e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="en_US">English (US)</option>
                      <option value="ru_RU">Russian</option>
                      <option value="es_ES">Spanish</option>
                      <option value="pt_PT">Portuguese (PT)</option>
                      <option value="pt_BR">Portuguese (BR)</option>
                      <option value="fr_FR">French</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Billing UUID
                    </label>
                    <input
                      type="text"
                      value={gameConfig.billing}
                      onChange={(e) => updateConfig("billing", e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="your_billing_uuid_here"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Session Token
                    </label>
                    <input
                      type="text"
                      value={gameConfig.token}
                      onChange={(e) => updateConfig("token", e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="userId|sessionId|hash"
                    />
                  </div>
                </div>
              )}

              <div className="mt-6 space-y-2">
                <button
                  onClick={copyConfigAsJSON}
                  className="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
                >
                  Copy Config as JSON
                </button>
                <button
                  onClick={copyProxyConfig}
                  className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm"
                >
                  Copy Proxy Setup Code
                </button>
              </div>
            </div>

            {/* Setup Instructions */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <h3 className="font-semibold text-amber-800 mb-2">
                Setup Required:
              </h3>
              <ol className="text-sm text-amber-700 space-y-1 list-decimal list-inside">
                <li>Replace billing UUID with your actual ABX billing UUID</li>
                <li>
                  Set up proxy routes in your backend (copy the proxy code
                  above)
                </li>
                <li>Ensure your server can reach ABX endpoints</li>
                <li>Test the game iframe below</li>
              </ol>
            </div>
          </div>

          {/* Game Iframe */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-700">
                  Game Preview
                </h2>
                <div className="text-sm text-gray-500">
                  {selectedGame
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </div>
              </div>

              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <iframe
                  src={`${APP_CONFIG.API_URL}abx/game-iframe/${selectedGame}`}
                  width="100%"
                  height="600"
                  frameBorder="0"
                  allow="fullscreen; autoplay; encrypted-media"
                  allowFullScreen
                  sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation"
                  title={`ABX Game: ${selectedGame}`}
                  className="w-full"
                />
              </div>

              <div className="mt-4 text-sm text-gray-600">
                <p>
                  <strong>Note:</strong> If the game doesn't load, check:
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Billing UUID is configured correctly</li>
                  <li>Proxy routes are set up in your backend</li>
                  <li>Network connectivity to ABX servers</li>
                  <li>Browser console for error messages</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ABXGamePlayer;
